import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITitleService = ( createDecorator('titleService'));
export { ITitleService };
